import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer-component" }
const _hoisted_2 = { class: "social-links" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "GitHub", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "LinkedIn", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "My CV", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" All rights reserved. ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Icons provided by ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Font Awesome")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(".")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GitHubIcon = _resolveComponent("GitHubIcon")!
  const _component_LinkComponent = _resolveComponent("LinkComponent")!
  const _component_LinkedInIcon = _resolveComponent("LinkedInIcon")!
  const _component_FileIcon = _resolveComponent("FileIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createVNode(_component_LinkComponent, { href: "https://github.com/wjbaker101" }, {
        default: _withCtx(() => [
          _createVNode(_component_GitHubIcon),
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_LinkComponent, { href: "https://linkedin.com/in/wjbaker101" }, {
        default: _withCtx(() => [
          _createVNode(_component_LinkedInIcon),
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/about/cv" }, {
        default: _withCtx(() => [
          _createVNode(_component_FileIcon),
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _createElementVNode("p", null, [
      _createTextVNode(" Copyright © William Baker 2015–" + _toDisplayString(new Date().getFullYear()) + ", ", 1),
      _hoisted_6,
      _hoisted_7
    ]),
    _createElementVNode("p", null, [
      _hoisted_8,
      _createVNode(_component_LinkComponent, { href: "https://fontawesome.com/license" }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }),
      _hoisted_10
    ])
  ]))
}